import * as React from "react";
import styles from "./filledButton.module.css";

function FilledButton({ name, clickHandler, className, dataDismiss, disabled="",type, id, ...props }) {
  return (
    <button disabled={disabled} className={`btn btn-primary ${styles.btnFilled} ${className}`} onClick={clickHandler} type={type} id={id} data-dismiss={dataDismiss} {...props}>{name}</button>
  );
}
export default FilledButton;
